import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { ReactComponent as Assembling } from '../../images/assembling.svg'
import { ReactComponent as Issue } from '../../images/issue.svg'
import { ReactComponent as Acceptance } from '../../images/acceptance.svg'
import { ReactComponent as Courier } from '../../images/courier.svg'
import { ReactComponent as Factory } from '../../images/factory.svg'
import { ReactComponent as Truck } from '../../images/truck.svg'
import { ReactComponent as Deliveryman } from '../../images/deliveryman.svg'
import { ReactComponent as FullTruck } from '../../images/fulltruck.svg'
import { ReactComponent as Repair } from '../../images/repair.svg'
import { ReactComponent as Network } from '../../images/network.svg'
import { ReactComponent as Invoice } from '../../images/invoice.svg'
import { ReactComponent as Inventory } from '../../images/inventory.svg'

import './btn.style.css'

interface Props {
  imageName: string
  text: string
  target: string
  textSecondary?: string
  inverted?: boolean
  maintenance?: boolean
  disabled?: boolean
}

export const ImageComponent = (name: string) => {
  switch (name) {
    case 'assembling':
      return <Assembling />
    case 'issue':
      return <Issue />
    case 'acceptance':
      return <Acceptance />
    case 'courier':
      return <Courier />
    case 'factory':
      return <Factory />
    case 'truck':
      return <Truck />
    case 'deliveryman':
      return <Deliveryman />
    case 'fulltruck':
      return <FullTruck />
    case 'distribution':
      return <Network />
    case 'invoice':
      return <Invoice />
    case 'inventory':
      return <Inventory />
    default:
      return null
  }
}

export const ImageButtonPanel = (props: Props) => {
  const { imageName, text, textSecondary, inverted, target, maintenance, disabled } = props

  const classnames = classNames('relative', {
    'image-btn-panel__maintenance': maintenance || disabled,
  })

  const renderBadge = () => (
    <div className="image-btn-panel__badge">
      <Repair></Repair>
      <span>Ведутся работы</span>
    </div>
  )

  return (
    <div className={classnames}>
      <Link className="decoration-none" to={target}>
        <div className="image-btn-panel__container">
          {!inverted && <div className="image-btn-panel__image">{ImageComponent(imageName)}</div>}
          <div className="image-btn-panel__text">
            <span className="image-btn-panel__text-main">{text}</span>
            <span className="image-btn-panel__text-secondary">{textSecondary}</span>
          </div>
          {inverted && <div className="image-btn-panel__image">{ImageComponent(imageName)}</div>}
        </div>
      </Link>
      {maintenance && renderBadge()}
    </div>
  )
}
